import { useEffect, useState } from "react";
import { AppState, Platform } from "react-native";

export function useAppVisibility() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (Platform.OS === "web") {
      const handleVisibilityChange = () => {
        setIsVisible(document.visibilityState === "visible");
      };
      document.addEventListener("visibilitychange", handleVisibilityChange);
      setIsVisible(document.visibilityState === "visible");
      return () => {
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange
        );
      };
    } else {
      const handleAppStateChange = (nextAppState: string) => {
        setIsVisible(nextAppState === "active");
      };
      const subscription = AppState.addEventListener(
        "change",
        handleAppStateChange
      );
      setIsVisible(AppState.currentState === "active");
      return () => {
        subscription.remove();
      };
    }
  }, []);

  return isVisible;
}
